import { render } from "./VModal.vue?vue&type=template&id=5e83da94"
import script from "./VModal.vue?vue&type=script&lang=ts"
export * from "./VModal.vue?vue&type=script&lang=ts"
script.render = render

export default script